module.exports = __webpack_public_path__ + "img/Mb_Exhibition_Logo.e5dabafa.jpg";